import { useDispatch } from 'react-redux';
import { setCurrentUser } from '../../store/userSlice'; // Adjust the import path accordingly
import { useToken } from './useToken';
import { useState, useEffect } from 'react';

export const useUser = () => {
  const [token] = useToken();
  const dispatch = useDispatch();

  const getPayloadFromToken = (token) => {
    if (
      !token ||
      typeof token !== 'string' ||
      token === 'null' ||
      token === 'undefined'
    ) {
      return null;
    }
    try {
      const parts = token.split('.');
      if (parts.length !== 3) {
        return null;
      }
      const encodedPayload = parts[1];
      if (!encodedPayload) {
        return null;
      }
      return JSON.parse(atob(encodedPayload));
    } catch (error) {
      // Don't log during logout process
      return null;
    }
  };

  const [user, setUser] = useState(() => {
    return getPayloadFromToken(token);
  });

  useEffect(() => {
    // Handle token changes with better error prevention
    const userPayload = getPayloadFromToken(token);
    setUser(userPayload);
    dispatch(setCurrentUser(userPayload));
  }, [token, dispatch]);

  return user;
};
